import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "../features/counter/counterSlice";
import nameReducer from "../features/name/nameSlice";
import companyReducer from "../features/company/companySlice";
import addressReducer from "../features/address/addressSlice";
import emailReducer from "../features/email/emailSlice";
import telephoneReducer from "../features/telephone/telephoneSlice";
import subjectReducer from "../features/subject/subjectSlice";
import messageReducer from "../features/message/messageSlice";
import bussinesstypeReducer from "../features/businesstype/bussinesstypeSlice";
import countryReducer from "../features/country/countrySlice";
import productgroupReducer from "../features/productgroup/productgroupSlice";
import producttypeReducer from "../features/producttype/producttypeSlice";
import languageReducer from "../features/language/languageSlice";
import scgBuReducer from "../features/scgbu/scgbuSlice";
import requestproductReducer from "../features/requestProduct/requestproductSlice";
import customercountryReducer from "../features/customercountry/customercountrySlice";
import snackAlertReducer from "../features/snackAlert/snackAlertSlice";
import attachedfileReducer from "../features/attachedfile/attachedfileSlice";
import consentReducer from "../features/consent/consentSlice";

export default configureStore({
  reducer: {
    counter: counterReducer,
    name: nameReducer,
    company: companyReducer,
    address: addressReducer,
    email: emailReducer,
    telephone: telephoneReducer,
    subject: subjectReducer,
    message: messageReducer,
    bussinesstype: bussinesstypeReducer,
    country: countryReducer,
    productgroup: productgroupReducer,
    producttype: producttypeReducer,
    language: languageReducer,
    scgbu: scgBuReducer,
    requestproduct: requestproductReducer,
    customercountry: customercountryReducer,
    snackAlert: snackAlertReducer,
    attachedfile: attachedfileReducer,
    consent: consentReducer,
  },
});
